// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Grid2, Stack, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
// Components, Layouts, Pages
import { BaseInput, BaseInputAddress } from '~/components/common';
// Others
import { IFormClient } from '~/utils/interface/client';
import { EMPTY_STRING } from '~/utils/constants/common';
import { IBaseAddress } from '~/utils/interface/common';
// Styles, images, icons
import styles from './AddressInfoClientForm.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const AddressInfoClientForm = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/client', 'common/base']);

  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext<IFormClient>();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleChangeAddress = (value: IBaseAddress) => {
    setValue('address', value.address ?? EMPTY_STRING, { shouldDirty: true });
    setValue('unitDetail', value.unitDetail ?? EMPTY_STRING, { shouldDirty: true });
    setValue('city', value.city ?? EMPTY_STRING, { shouldDirty: true });
    setValue('state', value.state ?? EMPTY_STRING, { shouldDirty: true });
    setValue('postalCode', value.postalCode ?? EMPTY_STRING, { shouldDirty: true });
    setValue('country', value.country ?? EMPTY_STRING, { shouldDirty: true });
    setValue('lat', String(value?.lat ?? 0), { shouldDirty: true });
    setValue('lng', String(value?.lng ?? 0), { shouldDirty: true });
  };
  //#endregion Handle Function

  return (
    <Stack id='addressInfoClientFormComponent' gap={'14px'}>
      <Typography className={cx('title')}>{t('client_form_title_address_information')}</Typography>

      <Grid2 container rowSpacing={3} columnSpacing={5}>
        <Grid2 size={6}>
          <Controller
            control={control}
            name={'address'}
            render={({ field: { onChange, value } }) => {
              return (
                <BaseInputAddress
                  height={36}
                  label={t('client_form_title_street_address')}
                  value={value}
                  onChange={onChange}
                  onSelectAddress={handleChangeAddress}
                  errorMessage={errors?.address?.message}
                />
              );
            }}
          />
        </Grid2>

        <Grid2 size={6}>
          <Controller
            control={control}
            name={'unitDetail'}
            render={({ field: { onChange, value } }) => {
              return (
                <BaseInput height={36} label={t('client_form_title_suite_unit')} value={value} onChange={onChange} />
              );
            }}
          />
        </Grid2>

        <Grid2 size={3}>
          <Controller
            control={control}
            name={'city'}
            render={({ field: { onChange, value } }) => {
              return <BaseInput height={36} label={t('client_form_title_city')} value={value} onChange={onChange} />;
            }}
          />
        </Grid2>

        <Grid2 size={3}>
          <Controller
            control={control}
            name={'state'}
            render={({ field: { onChange, value } }) => {
              return <BaseInput height={36} label={t('client_form_title_state')} value={value} onChange={onChange} />;
            }}
          />
        </Grid2>

        <Grid2 size={3}>
          <Controller
            control={control}
            name={'postalCode'}
            render={({ field: { onChange, value } }) => {
              return (
                <BaseInput height={36} label={t('client_form_title_zip_code')} value={value} onChange={onChange} />
              );
            }}
          />
        </Grid2>

        <Grid2 size={3}>
          <Controller
            control={control}
            name={'country'}
            render={({ field: { onChange, value } }) => {
              return <BaseInput height={36} label={t('client_form_title_country')} value={value} onChange={onChange} />;
            }}
          />
        </Grid2>
      </Grid2>
    </Stack>
  );
};

export default AddressInfoClientForm;
